import MegaNaviPC from './meganaviPC'; /* オープン、クローズを使いたいので呼び出し */

const meganaviPC = new MegaNaviPC($("#l-header__navi"),$("#l-header__navi-list>ul>li"),$('#c-overlay'));

export default class MegaNaviTablet {
    constructor($navi,$naviList,$overlay,$Acc){
        this.$navi = $navi;
        this.$naviList = $naviList;
        this.$overlay = $overlay;

        this.$Acc = $Acc;
    }
    init(){

        let _this = this;
        if(!$('html.tablet')[0]) return;

        _this.$naviList.children('.l-header__meganavi-acc').on("click",function(){
            // if($('html.tablet')[0]){
                let $target = $(this);
                if($target.hasClass('open')){
                    _this.$Acc.removeClass('open');
                    meganaviPC.meganavi($target.parent('li'),'hide');
                    $('#l-header').removeClass('transparent');
                    $('body').addClass('meganavi-open');
                }else{
                    _this.$Acc.removeClass('open');
                    $target.addClass('open');
                    meganaviPC.meganavi(_this.$naviList.not($target.parent('li')),'hide');
                    meganaviPC.meganavi($target.parent('li'),'show');
                    // scr = $(window).scrollTop();
                    // header.color(scr);
                    $('body').removeClass('meganavi-open');
                }
                return false;
            // }
        });

        _this.$overlay.on("click",function(){
            let $target = $(".l-header__meganavi-acc.open").parent('li');
            _this.$Acc.removeClass('open');
            meganaviPC.meganavi($target,'hide');
            // scr = $(window).scrollTop();
            // header.color(scr);
            $('body').removeClass('meganavi-open');
        });

    }

    resize(){

    }
}